import React, {useState, useEffect, useRef} from 'react';
import * as S from '../../../../styles/core-styles/AdminTools-styles';
import { convertToPlainText } from '../UtilityFunctions';

export default function Search(props){
    const [activeSearch, setActiveSearch] = useState('')
    const {allValues, searchColumns, setMatchingValues, reloadTable, skipPageResetRef, disabled, accentInsensitive} = props
    const searchColAccessorsRef = useRef(null);
    searchColAccessorsRef.current = searchColumns
      ? searchColumns.filter((column) => column.showInSearch === true).map(column => column.accessor)
      : null;

    useEffect(()=>{
            if (activeSearch !== null && activeSearch !== undefined && activeSearch !== '') {
              let searchTerm = accentInsensitive ? convertToPlainText(activeSearch.toString()) : activeSearch.toString().toLowerCase();
              const matchingValues = allValues?.filter((item) => {
                if (searchColAccessorsRef.current) {
                  return searchColAccessorsRef.current.some((key) => {
                    const value = item?.[key];
                    if (value == null) {
                        return false;
                    }

                    const normalizedCellValue = accentInsensitive
                        ? convertToPlainText(String(value))
                        : String(value).toLowerCase();

                    return normalizedCellValue.includes(searchTerm);
                  });
                }
                else {
                  return Object.values(item).some((value) => {
                    if (value == null) {
                        return false;
                    }

                    const normalizedCellValue = accentInsensitive
                        ? convertToPlainText(String(value))
                        : String(value).toLowerCase();

                    return normalizedCellValue.includes(searchTerm);
                  });
                }
              });
              setMatchingValues(matchingValues)
            } else {
              return setMatchingValues(allValues);
            }
          if (reloadTable) reloadTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[activeSearch, allValues]);
    
    //skipPageResetRef control needs to be seperate to prevent table page from resetting when allValues is updated.
    useEffect(() => {
      if(skipPageResetRef) skipPageResetRef.current = true;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[activeSearch])
    let placeholderText = disabled ? '' : 'Search'

    return(
      <S.SearchBar>
        <S.SearchInput value={activeSearch} onChange={(e) => setActiveSearch(e.target.value)} placeholder={placeholderText} disabled={disabled}/>
      </S.SearchBar>
    );

}